import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import './registerComponents'

import 'reset.css'

Vue.config.productionTip = false
if (window.navigator.userAgent.indexOf('MSIE') >= 1) {
  alert('您的浏览器版本过低 请使用IE11、360、谷歌等高版本浏览器访问')
} else {
  new Vue({
    router,
    render: h => h(App),
  }).$mount('#app')
}
